import { Container, ErrorMessage, Label } from "./InputWrapper.styles";
import { InputWrapperProps } from "./InputWrapper.types";
import { createErrorMessage } from "./InputWrapper.utils";

export const InputWrapper = ({ label, isRequired, children, errorMessage }: InputWrapperProps) => (
  <Container>
    {label ? <Label isRequired={isRequired}>{label}</Label> : null}
    {children}
    {errorMessage ? <ErrorMessage isRequired={isRequired}>{createErrorMessage(errorMessage)}</ErrorMessage> : null}
  </Container>
);
